import editBannerDownload from './routes/banner/Banner.vue';

const downloadRoutes = [
  {
    path: '/banner-download',
    name: 'editBannerDownload',
    component: editBannerDownload,
  },
];

export default downloadRoutes;
